export default {
	personalCenter: {
		vip_member: 'VIP Membership',
		vip: {
			level_label: 'VIP{level} Level', next_level: 'Next level: VIP{level}',
			points_summary: '{current} points earned. {remaining} more needed for VIP{level}.',
			level_rewards: 'Level rewards', reward_title: 'VIP{level} Rewards', exclusive_rewards: 'Exclusive Rewards', promotion_reward: 'VIP{level} promotion reward',
			previous_level: 'Previous level', next_level_button: 'Next level',
			dragon_key: 'Dragon Soul Key ×{count}', battle_shard: 'Battle Crest Shard ×{count}', forge_crystal: 'Forge Crystal ×{count}',
			unlocked: 'VIP{level} reached. Reward available.', locked: 'VIP{level} has not been reached.',
			claim: 'Claim', claiming: 'Claiming...', claimed: 'Claimed', claim_success: 'VIP{level} reward claimed', claim_failed: 'Failed to claim reward. Please try again later.',
			points_label: 'Points', go_redeem: 'Redeem',
			experience_summary: 'Current EXP: {current}; {remaining} EXP needed for VIP{level}',
			max_level: 'MAX LEVEL!', current_experience: 'Current EXP: {current}'
		},
		title: 'Personal Center', my_exchange: 'My Redemptions', my_points: 'My Points', lottery_records: 'Lottery Records', recharge_records: 'Top-up Records',
		redeem_gift: 'Redeem Gift', redeem_description: 'Enter a redemption code to send the reward to the selected character.', redeem_code: 'Redemption Code', redeem_code_placeholder: 'Enter redemption code', redeeming: 'Redeeming...', redeem_now: 'Redeem Now', rebate_coupon: '{percent}% Rebate Coupon',
		points_details: 'Points Details', exchange_time: 'Redemption Time', reward_content: 'Reward', status: 'Status', time: 'Time', type: 'Type', points_change: 'Points Change', balance: 'Balance', lottery_time: 'Lottery Time', reward: 'Reward',
		order_id: 'Order ID', payment_channel: 'Payment Method', amount: 'Amount', server: 'Server', role: 'Character', payment_time: 'Payment Time', copy: 'Copy',
		loading: 'Loading...', no_records: 'No matching records', no_content: 'There is currently no content to display.', previous: 'Previous', next: 'Next', page_info: 'Page {current} / {total}',
		source_recharge_reward: 'Top-up Reward', source_official_activity: 'Official Event', source_item_exchange: 'Item Exchange',
		exchange_success: 'Redeemed successfully', exchange_failed: 'Redemption failed', enter_redeem_code: 'Enter a redemption code', exchange_retry: 'Redemption failed. Please try again later.',
		copy_success: 'Copied successfully', copy_failed: 'Copy failed', lottery_load_failed: 'Failed to load lottery records', lottery_load_retry: 'Failed to load lottery records. Please try again later.',
		recharge_load_failed: 'Failed to load top-up records', recharge_load_retry: 'Failed to load top-up records. Please try again later.', points_load_failed: 'Failed to load points records', points_load_retry: 'Failed to load points records. Please try again later.',
		exchange_records_load_failed: 'Failed to load redemption records', exchange_records_load_retry: 'Failed to load redemption records. Please try again later.'
	},
	member_popup: {
		title: 'Membership points added!',
		message: 'You earned {points} membership points from this top-up. {remaining} more points are needed for VIP{nextLevel}.',
		progress: 'Total top-up points {current} / {target}',
		next: '{remaining} more points needed for VIP{nextLevel}',
		suppress: 'Do not show again for 7 days',
		later: 'Maybe later',
		rewards: 'View rewards',
		close: 'Close membership notice'
	},
	member_level: {
		title: 'Member level',
		points_progress: 'Recharge points',
		next_level: 'Points needed for VIP{level}:',
		points_unit: 'points',
		view_rewards: 'View level rewards'
	},
	login_button_text: 'Login in',
	logining_button_text: 'Logging in',
	account_input_text: 'Enter your binding mail',
	password_input_text: 'Please enter password',
	other_login_methods_text: 'Other login methods',
	top_up_center_text: 'Top-up Center',
	benefit_text: 'Benefit',
	limited_event_text: 'Limited Event',
	sign_in_text: 'Sign in',
	log_out_text: 'Log out',
	service_terms_text: 'Service Terms',
	privacy_policy_text: 'Privacy Policy',
	official_apk_download_text: 'Official APK Download',
	official_facebook_text: 'Official Facebook',
	recharge_instructions_text: 'Recharge instructions',
	rebate_countdown_title: 'Limited-Time Rebate Active',
	rebate_countdown_label: 'Countdown',
	rebate_countdown_days: 'Days',
	rebate_countdown_hours: 'Hours',
	rebate_countdown_minutes: 'Mins',
	rebate_countdown_seconds: 'Secs',
	log_in_game_account_text: 'log in to your game account',
	sign_in_lowercase_text: 'sign in',
	instructions_text: 'Instructions',
	confirm_text: 'Confirm',
	switch_character_text: 'Switch Character',
	copy_successful_text: 'Copy successful',
	claimed_text: 'Claimed',
	claim_success_text: 'Claimed Successfully',
	claim_text: 'Claim',
	claim_unmet_text: 'Not eligible',
	contact_customer_service_text: 'Contact Customer Service',
	home_page_text: 'Home Page',
	payment_successful_text: 'Payment successful',
	purchase_confirm_text: 'Purchase Confirm',
	payment_channels_text: 'Payment Channels',
	payment_button_text: 'Pay',
	original_price_text: 'Original Price',
	discounts_text: 'Discounts',
	earn_points_text: 'Earn Points',
	rebates_text: 'Rebates',
	amount_text: 'Amount',
	insufficient_points_text: 'Insufficient points',
	insufficient_lottery_count_text: 'No lottery chances remaining',
	network_error_retry_text: 'Network error. Please try again later.',
	score_lottery_text: 'Points Lottery',
	score_lottery_entrance_error: 'Failed to request score lottery entrance:',
	lottery_current_points_label: 'Current Points:',
	lottery_points_recharge_tip: 'Points can be earned through top-up',
	lottery_spin_label: 'Wheel Draw',
	lottery_rule_button: 'Rules',
	lottery_rule_popup_title: 'Event Rules',
	lottery_record_button: 'Prize Records',
	lottery_record_title: 'Prize Records',
	lottery_record_empty: 'No records',
	lottery_record_time: 'Time',
	lottery_record_prize: 'Prize',
	lottery_daily_limit: 'Daily limit reached',
	lottery_remaining_count: 'Remaining chances {count}',
	lottery_draw_cost: '{cost} points',
	lottery_init_data_error: 'Failed to request score lottery data:',
	daily_rewards_text: 'Daily Rewards',
	points_text: 'Points Store',
	winning_award_text: "You're a winner!",
	receive_reward_tips_text: "The reward has been sent to your character's mailbox, please log in to your character to claim it!",
	hot_title_text: "HOT",
	other_title_text: "Other",
	limit_title_text: "LIMIT",
	limit_text: "Limit",
	sell_out_text: "Sold Out",
	copy_fail_text: "Copy failed",
	payment_type_text: "Payment method",
	order_id_text: "Order ID",
	payment_time_text: "Payment time",
	copy_text: "Copy",
	amount_text: "Amount",
	game_server_text: "Server",
	game_role_text: "Character",
	orders_records_text: "Top-up history",
	no_data_text: 'No data available',
	orders_tips_text: "System settings limit top-up history queries to the most recent 30 days",
	pointsDescribeText: '',
	pointsBalanceText: '',
	points_period_daily: 'Daily',
	points_period_week: 'Weekly',
	points_period_month: 'Monthly',
	points_period_lifetime: 'Lifetime',
	points_tag_mustBuy: 'Must-Buy',
	points_tag_selected: 'Selected',
	points_tag_discount: 'Discount',
	points_tag_perk: 'Perk',
	coupon: {
		discount_label: 'Payback',
		title_html: 'Use a payback coupon to receive payback after purchase.<br/>',
		expired_text: 'Expired',
		used_text: 'Used',
		countdown_prefix: 'Countdown',
		activity_button_text: 'Payback Coupon Draw'
	},
	pagination: {
		previous: "Previous",
		next: "Next",
		page_info: "Page {current} of {total}"
	},
	support_my_questions: 'My Questions',
	support_submit_issue: 'Submit Issue',
	support_records_title: 'My Issue Records',
	support_records_desc: 'Check progress and add more information.',
	support_refresh: 'Refresh',
	support_tabs_label: 'Customer support tabs',
	support_load_more: 'Load More',
	support_user_id: 'User ID',
	support_game: 'Game',
	support_platform: 'Platform',
	support_back: 'Back',
	support_mark_solved: 'Solved',
	support_official_support: 'Official Support',
	support_image: 'Image',
	support_reply_hint: 'Your update will be sent to support',
	support_send: 'Send',
	support_sending: 'Sending...',
	support_player: 'Player',
	support_attachment_preview: 'Attachment preview',
	support_remove_attachment: 'Remove attachment',
	support_attachment_fallback: 'Attachment',
	support_survey_title: 'Survey Prompt',
	support_survey_message: 'Has your issue been resolved?',
	support_survey_close: 'Close',
	support_submit_success: 'Submitted successfully',
	support_submit_fail: 'Submission failed',
	support_close_success: 'Chat closed',
	support_close_fail: 'Close failed',
	support_rate_title: 'Please rate this service',
	support_input_placeholder: 'Please enter content...',
	support_image_pick_error: 'Failed to get image path',
	support_send_fail: 'Send failed',
	support_evaluate_success: 'Evaluation successful',
	support_evaluate_fail: 'Evaluation failed',
	support_status_unreplied: 'Unreplied',
	support_status_replied: 'Replied',
	support_status_resolved: 'Resolved',
	support_status_pending_review: 'Pending review',
	support_form_type_label: 'Issue Type',
	support_form_type_placeholder: 'Please select issue type',
	support_form_desc_label: 'Issue Description',
	support_form_desc_placeholder: 'Please describe the issue in detail...',
	support_form_upload_label: 'Attachments',
	support_form_upload_click: 'Click to upload files',
	support_form_upload_tips: '(Screenshots ≤10MB, videos ≤50MB, up to 5 files)',
	support_form_submit: 'Submit',
	support_form_image_too_big: 'Image size cannot exceed 10MB',
	support_form_video_too_big: 'Video size cannot exceed 50MB',
	cancel_text: 'Cancel',
	// Support types
	support_type_topup: 'Top-up Issue',
	support_type_account: 'Account Issue',
	support_type_guide: 'Gameplay Guidance',
	support_type_suggestion: 'Suggestions',
	support_type_event: 'Event Issue',
	support_type_report: 'Violation Report',
	support_type_other: 'Other',
	support_type_topup_hint: 'Missing top-up, wrong amount',
	support_type_account_hint: 'Login, ban, binding',
	support_type_guide_hint: 'Gameplay, quests, progress',
	support_type_suggestion_hint: 'Feedback and ideas',
	support_type_report_hint: 'Cheating, abuse, violations',
	support_type_other_hint: 'Uncategorized issue',
	support_type_topup_code: 'Pay',
	support_type_account_code: 'Acc',
	support_type_guide_code: 'Tip',
	support_type_suggestion_code: 'Idea',
	support_type_report_code: 'Rpt',
	support_type_other_code: 'Etc',
	support_submitting: 'Submitting...',
	rebate_limited_text: '🔥 Limited-Time {pct}% Rebate',
	rebate_percent_text: '{pct}% Rebate',
	coupon_booster_label: 'Rebate Coupon',
	coupon_expires_after: 'Expires in {time}',
	coupon_threshold_shortfall: 'Spend {amount} more to use',
	coupon_product_excluded: 'Not available for this product',
	coupon_channel_restricted: 'Only available with {channels}',
	coupon_unavailable_title: 'Unavailable coupons',
	coupon_skip_text: 'No coupon',
	coupon_count_unit: '',
	coupon_picker_title: 'Select Coupon',
	coupon_entry_label: 'Coupon',
	coupon_available_count: '{count} available',
	coupon_no_use_text: 'No coupon',
	coupon_best_tag: 'Best',
	coupon_expired_text: 'Expired',
	close_text: 'Close',
	discount_coupon_label: 'Discount Coupon',
	coupon_single_use_hint: 'One coupon can be used per order',
	order_amount_text: 'Order amount',
	discount_amount_text: 'Coupon discount',
	payable_amount_text: 'Amount due',
	coupon_extra_rebate_notice: 'The extra 50% rebate will be delivered by mail. Please contact support to register it.',
	payment_recommended_text: 'Recommended payment',
	payment_enjoy_rebate: 'Enjoy {pct}% Rebate',
	payment_order_rebate: 'Order rebate {amount}',
	payment_order_discount: 'Order discount {amount}',
	recommend_text: 'Recommended',
	payment_other_methods_text: 'Other payment methods',
	super_coupon_title: 'Limited-Time Super Coupon',
	super_coupon_end_time: 'Event ends:',
	super_coupon_previous_activity: 'Previous super coupon offer',
	super_coupon_recommended: 'Top Pick',
	super_coupon_view_details: 'View coupon pack details',
	super_coupon_value_label: 'Total Discount Value',
	super_coupon_contents: 'Coupon pack contents',
	super_coupon_threshold: 'Spend {amount}',
	super_coupon_discount: 'Save {amount}',
	super_coupon_remaining: '{time} remaining',
	super_coupon_purchased: 'Purchased',
	super_coupon_buy_now: 'Buy Now',
	super_coupon_next_activity: 'Next super coupon offer',
	super_coupon_switcher: 'Super coupon offer navigation',
	super_coupon_switch_to: 'Go to super coupon offer {index}',
	super_coupon_details_title: 'Super Coupon Pack Details',
	super_coupon_close_details: 'Close coupon pack details',
	super_coupon_empty: 'No discount coupons available',
	super_coupon_instructions: 'Usage Instructions',
	super_coupon_confirm: 'Got It',
	super_coupon_package_name: 'Super Coupon Pack',
	super_coupon_get_coupons: 'Get {count} discount coupons instantly',
	super_coupon_reward_multiple: 'Approx. {multiple}x value',
	super_coupon_purchase_limit: 'Limit {count} packs per purchase',
	super_coupon_purchase_interval: 'Purchase interval: {days} days',
	super_coupon_rule_separator: ', ',
	super_coupon_unknown_status: 'Unknown status',
	super_coupon_date_format: '{month}/{day}/{year} {time}',
	super_coupon_used: 'Used',
	super_coupon_expired: 'Expired',
	super_coupon_unit_day: 'day',
	super_coupon_unit_days: 'days',
	super_coupon_unit_hour: 'hour',
	super_coupon_unit_hours: 'hours',
	super_coupon_unit_minute: 'minute',
	super_coupon_unit_minutes: 'minutes',
	super_coupon_valid_for: 'Valid for {value} {unit}'
}
